import { AuthHelpCameFrom, CountryGroup } from '@/types/auth';
import { TriggeredFromSection } from '@/types/common';

export enum EventType {
  'ON_PAYMENT_CANCEL' = 'on_payment_cancel',
  'MWEB_ENROLL_CLICK' = 'mweb_enroll_click',
  'ORDER_SUMMARY_BACK' = 'order_summary_back',
  'MARKET_BOOK_SEAT' = 'market_book_seat',
  'MARKET_ENROLL_CLICK' = 'market_enroll_click',
  'MARKET_PAGE_VISIT' = 'market_page_visit',
  'BLP_PAGE_VISIT' = 'blp_page_visit',
  'BLP_ENROLL_CLICK' = 'blp_enroll_click',
  'PAGE_OPEN' = 'page_open',
  'HOME_PAGE_OPEN' = 'home_page_open',
  'CLASS_FILTER_SELECT' = 'class_filter_select',
  'LOGIN_CLICK' = 'login_click',
  'FORM_SUBMIT_CLICK' = 'form_submit_click',
  'BOOK_FREE_CLASS' = 'book_free_class',
  'OTP_SENT' = 'otp_sent',
  'OTP_RESEND_CLICK' = 'otp_resend_click',
  'SIGNUP_SUCCESS' = 'signup_success',
  'PROFILE_CLICK' = 'profile_click',
  'LOGOUT_CLICK' = 'logout_click',
  'EXPLORE_COURSES_CLICK' = 'explore_courses_click',
  'ANIMATED_VIDEO_CLICK' = 'animated_video_click',
  'BOOK_DEMO_CLICK' = 'book_demo_click',
  'DEMO_REGISTERED' = 'demo_registered',
  'JOIN_DEMO_CLICK' = 'join_demo_click',
  'BATCH_EXPLORE_CLICK' = 'batch_explore_click',
  'BATCH_SHARE_CLICK' = 'batch_share_click',
  'TRANSACTION_SUCCESS' = 'transaction_success',
  'TRANSACTION_SUCCESS_MASTER' = 'master_transaction_success',
  'TRANSACTION_SUCCESS_BOOSTER' = 'booster_transaction_success',
  'TRANSACTION_SUCCESS_MEGA' = 'mega_transaction_success',
  'TRANSACTION_SUCCESS_POWER' = 'power_transaction_success',
  'TRANSACTION_SUCCESS_POCKET' = 'pocket_transaction_success',
  'LOGIN_SUCCESS' = 'login_success',
  'SIGNIN_SUCCESS' = 'signin_success',
  'CONTINUE_CLICK' = 'continue_click',
  'BATCH_ITEM_CLICK' = 'batch_item_click',
  'BUY_NOW_CLICK' = 'buy_now_click',
  'PAY_NOW_CLICK' = 'pay_now_click',
  'TEACHER_PROFILE_CLICK' = 'teacher_profile_click',
  'CHECKOUT_SCHEDULE_CLICK' = 'checkout_schedule_click',
  'FAQ_CLICK' = 'faq_click',
  'DEMO_VIDEO_CLICK' = 'demo_video_click',
  'STUDY_SUBJECT_CHANGE' = 'study_subject_change',
  'TOPIC_CLICK' = 'topic_click',
  'SCHEDULE_CLICK' = 'schedule_click',
  'FOOTER_ITEM_CLICK' = 'footer_item_click',
  'BATCH_PAGE_VISIT' = 'batch_page_visit',
  'TRANSACTION_FAILED' = 'transaction_failed',
  'OTP_FAILED' = 'otp_failed',
  'API_TIMEOUT' = 'api_timeout',
  'APPLY_COUPON_CLICK' = 'apply_coupon_click',
  'VIEW_ALL_COUPONS_CLICK' = 'view_all_coupons_click',
  'ORDER_SUMMARY_VISIT' = 'order_summary_visit',
  'COHORT_CHANGE' = 'cohort_change',
  'START_TEST' = 'start_test',
  'TEST_SUBMIT_SUBJECTIVE' = 'test_submit_subjective',
  'TRANSACTION_CANCEL' = 'transaction_cancel',
  'ONBOARDING_DETAILS_FILLED' = 'onboarding_details_filled',
  'BATCH_ENROLL_FREE' = 'batch_enroll_free',
  'BOOK_A_DEMO_CLICK' = 'book_a_demo_click',
  'DEMO_PAGE_VISIT' = 'demo_page_visit',
  'DEMO_ENROLL_CLICK' = 'demo_enroll_click',
  'DEMO_BOOK_SEAT' = 'demo_book_seat',
  'CLOSE_POPUP' = 'close_popup',
  'HELP_CLICK' = 'help_click',
  'HELP_SUBMIT_CLICK' = 'help_submit_click',
  'COUNTRY_CHANGE' = 'country_change',
  'TAKE_A_QUIZ' = 'take_a_quiz',
  'START_QUIZ' = 'start_quiz',
  'QUIZ_PROGRESS' = 'quiz_progress',
  'QUIZ_SUBMIT' = 'quiz_submit',
  'WA_SALES_CTA_CLICK' = 'wa_cta_click',
  'WA_CTA' = 'wa_cta',
  'HOMEPAGE_VISIT' = 'homepage_visit',
  'REPORT_CARD_CLICK' = 'report_card_click',
  'ERROR_IN_PURCHASE' = 'error_in_purchase',
  'SHARE_CLICK' = 'share_click',
  'REPORT_CARD_CTA_CLICK' = 'report_card_cta_click',
  'REPORT_CARD_VISIT' = 'report_card_visit',
  'UNLOCK_REPORT_CLICK' = 'unlock_report_click',
  'BADGE_CLICK' = 'badge_click',
  'DETAILED_VIEW_OPEN' = 'detailed_view_open',
  'PAYMENT_SUCCESS_VISIT' = 'payment_success_visit',
  'INVOICE_DOWNLOAD_CLICK' = 'invoice_download_click',
  'RECEIPT_CLICK' = 'receipt_click',
  'MY_PURCHASE_CLICK' = 'my_purchase_click',
  'BOOK_SLOT_SUCCESS' = 'book_slot_success',
  'MENTOR_SUPPORT_CLICK' = 'mentor_support_click',
  'BOOK_SLOT_NOW' = 'book_slot_now',
  'REFER_BANNER_CLICK' = 'refer_banner_click',
  'REFER_NOW_PAGE_OPEN' = 'refer_now_page_open',
  'REFER_NOW_VIDEO_CLICK' = 'refer_now_video_click',
  'REFER_NOW_FAQ_CLICK' = 'refer_now_FAQ_click',
  'INVITE_FRIENDS_CTA_CLICK' = 'invite_friends_cta_click',
  'KEEP_REFERRING_PAGE_OPEN' = 'keep_refering_page_open',
  'KEEP_REFERRING_FAQ_CLICK' = 'keep_referring_FAQ_click',
  'KEEP_REFERRING_SHOW_DETAILS' = 'keep_referring_show_details',
  'CLAIM_REWARD_CLICK' = 'claim_reward_click',
  'ALL_REWARD_CLAIM_POPUP' = 'all_reward_claim_popup',
  'BOOSTER_BANNER' = 'booster_banner',
  'EXPERIMENT_OFFERINGS' = 'experiment_offerings',
  EXPERIMENT_OFFERING_CLICKED = 'experiment_offering_clicked',

  // Pre Purchase Revamp Events
  'BATCH_THUMBNAIL_VIDEO_CLICK' = 'batch_thumbnail_video_click',
  'COHORT_CHANGE_CLICK' = 'cohort_change_click',
  'TRACK_CONTENT_OPEN' = 'track_content_open',
  'VIEW_ALL_TRACK_CLICK' = 'view_all_track_click',
  'ALL_TRACK_PAGE_OPEN' = 'all_track_page_open',
  'TRACK_PURCHASE_POPUP' = 'track_purchase_popup',
  'TAGGED_BATCHES_POPUP' = 'tagged_batches_popup',
  'TAGGED_BATCH_SELECTED' = 'tagged_batch_selected',
  'CONTINUE_TO_PAY_CLICK' = 'continue_to_pay_click',
  'TRACK_CONTENT_CLICK' = 'track_content_click',
  'STUDY_CONTENT_CLICK' = 'study_content_click',
  'TIMELINE_SWITCH' = 'timeline_switch',
  'CERTIFICATE_VIEW' = 'certificate_view',
  'CERTIFICATE_SHARE' = 'certificate_share',
  'MENTOR_CONNECT_CLICK' = 'mentor_connect_click',
  'MENTOR_CHAT_INTRO_BS_SHOWN' = 'mentor_chat_intro_bs_shown',
  'MENTOR_CHAT_INTRO_BS_CTA_CLICK' = 'mentor_chat_intro_bs_cta_click',
  'MENTOR_CHAT_INTRO_BS_DISMISSED' = 'mentor_chat_intro_bs_dismissed',
  'MENTOR_CHAT_SCREEN_OPENED' = 'mentor_chat_screen_opened',
  'MENTOR_CHAT_MESSAGE_SENT' = 'mentor_chat_message_sent',
  'MENTOR_CHAT_APP_DOWNLOAD' = 'mentor_chat_app_download',
  'ASK_MENTOR_CHAT_SENT' = 'ask_mentor_chat_sent',
  'CLASS_CONTENT_CLICK' = 'class_content_click',
  'CLASS_CONTENT_ACTION' = 'class_content_action',
  'NO_COHORT_DATA' = 'no_cohort_data',
  'PLAYSTORE_RATE_NOW_CLICK' = 'playstore_rate_now_click',
  'PHYSICSWALLAH_REDIRECTION' = 'physicswallah_redirection',
  'SWITCH_NOW_BUTTON' = 'switch_now_button',

  /** New dedicated events (do not replace page_open); same payload shape. */
  'COMPARE_BATCHES_PAGE' = 'compare_batches_page',
  'BATCH_LISTING_PAGE' = 'batch_listing_page',
  'CUSTOM_BANNER_CLICK' = 'custom_banner_click',
  'RETENTION_CLICK_EXTERNAL' = 'retention_click_external',
  'POSTCLASS_RATING' = 'postclass_rating',
  'ADDRESS_ADD_CLICKED' = 'address_add_clicked',
  'ADDRESS_SUBMITTED' = 'address_submitted',
  'NON_SERVICEABILITY' = 'non_serviceability',
  'GENERIC_BANNER_VISIBILITY' = 'generic_banner_visibility',
  'GENERIC_BANNER_CLICKED' = 'generic_banner_clicked',
  'EXAM_PAGE_OPEN' = 'exam_page_open',
  'EXAM_PAGE_ITEM_CLICK' = 'exam_page_item_click',
  'EXAM_PAGE_ITEM_SHARE' = 'exam_page_item_share',
  'EXAM_PAGE_COMPLETED' = 'exam_page_completed',
  'EXAM_PAGE_MENTOR_CLICK' = 'exam_page_mentor_click',
  'REFUND_PAGE_VISIT' = 'refund_page_visit',
  'UPI_VERIFICATION_ATTEMPTED' = 'upi_verification_attempted',
  'PROCEED_WITH_REFUND_CLICKED' = 'proceed_with_refund_clicked',
  'REFUND_STATUS_UPDATED' = 'refund_status_updated',
  'FLOATING_NOTIFICATION_SHOWN' = 'floating_notification_shown',
  'FLOATING_NOTIFICATION_CLICKED' = 'floating_notification_clicked',
  'STREAK_ACT_NOW_CLICKED' = 'streak_act_now_clicked',
  'DOWNLOAD_BUTTON_CLICKED' = 'download_button_clicked',
  'BOTTOM_SHEET_INTERACTION' = 'bottom_sheet_interaction',
}

export type RefundAnalyticsStatus =
  | 'refund_eligible'
  | 'refund_ineligible'
  | 'refund_processing'
  | 'refund_success'
  | 'refund_failed';

export type RefundStatusUpdatedStatus = 'refund_success' | 'refund_failed' | 'refund_processing';

export interface RefundAnalyticsBaseParams {
  refund_id?: string;
  order_id?: string;
  source?: 'web' | 'mweb';
  page_location?: string;
}

export interface RefundPageVisitParams extends RefundAnalyticsBaseParams {
  has_active_refund: boolean;
  refund_status: RefundAnalyticsStatus;
}

export interface UpiVerificationAttemptedParams extends RefundAnalyticsBaseParams {
  verification_status: boolean;
}

export interface ProceedWithRefundClickedParams extends RefundAnalyticsBaseParams {
  selected_option: 'yes' | 'no';
}

export interface RefundStatusUpdatedParams extends RefundAnalyticsBaseParams {
  refund_status: RefundStatusUpdatedStatus;
}

export interface PwEvent {
  type: EventType;
}

export type HelpClickParamsType = {
  user_number: string;
  user_country_code: string;
  came_from: AuthHelpCameFrom;
};

export interface HelpSubmitClickParamsType {
  user_number: string;
  user_country_code: string;
  came_from: AuthHelpCameFrom;
  user_name: string;
  user_email: string;
}

export interface CountryChangeParams {
  click_section: string;
  page: string;
  prev_country: string;
  new_country: string;
}

export interface WaSalesCtaClickParams {
  country: CountryGroup;
  user_number: string;
}

export interface WaCTAParams {
  is_visible: 'yes' | 'no';
}

export type BUY_NOW_CLICK_PAGE =
  | 'landing'
  | 'home'
  | 'paid'
  | 'batch_page'
  | 'quiz_result_page'
  | 'study_room';

// Pre Purchase Revamp Event Parameter Types
export type GoodiesVisibleValue = 'true' | 'false' | 'NA';

export interface PageOpenParams {
  page: 'home' | 'paid';
  user_id: string;
  user_cohort: string;
  selected_cohort?: string;
  came_from?: 'login' | 'signup' | 'thank_you_page';
  paid_batch_name?: string[];
  paid_batch_id?: string[];
  paid_batch_type?: 'booster' | 'master';
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web';
  user_country?: string;
  flow?: 'revamped' | 'old';
  tracks_shown?: 'brainBytes' | 'practice' | 'animated';
  brainbytes_unlocked?: number;
  practice_unlocked?: number;
  animated_unlocked?: number;
  booster_batch_shown?: string;
  schedule_status?: 'no_class_today' | 'no_schedule' | 'slot_booking';
  experiment_name?: string;
  goodies_visible?: GoodiesVisibleValue;
}

export type GoodiesAddressCameFrom = 'paid_page' | 'profile_page' | 'thank_you_page';

export type GoodiesAddressType = 'saved_address' | 'newly_added';

export interface GoodiesAddressEventPayload {
  came_from: GoodiesAddressCameFrom;
  batch_id: string;
  batch_type: string;
}

export interface AddressSubmittedParams extends GoodiesAddressEventPayload {
  address_type: GoodiesAddressType;
}

export interface NonServiceabilityParams extends GoodiesAddressEventPayload {
  error_code: string;
  non_serviceable_pincode: string;
}

/** Event-specific fields only; user metadata is merged via `is_user_status_required`. */
export interface GenericBannerVisibilityParams {
  selected_cohort: string;
  page_location: string;
  platform: string;
  source: string;
}

export interface GenericBannerClickedParams {
  selected_cohort: string;
  page_link: string;
  platform: string;
  source: string;
}

export interface ExamPageOpenParams {
  selected_cohort: string;
  page_link: string;
  platform: string;
  source: string;
  came_from: 'home' | 'deeplink';
}

export type ExamPageMentorClickParams = ExamPageOpenParams;

export interface ExamPageItemParams {
  selected_cohort: string;
  page_link: string;
  platform: string;
  source: string;
  came_from: 'home' | 'deeplink';
  item_name: string;
  item_subject: string;
  item_board: string;
}

export interface BatchThumbnailVideoClickParams {
  user_id: string;
  user_cohort: string;
  selected_cohort?: string;
  user_name?: string;
  user_class?: string;
  source?: string;
  user_country?: string;
  flow?: string;
  booster_batch_shown?: string;
}

export interface CohortChangeClickParams {
  came_from: 'home' | 'explore';
  page: 'home' | 'paid';
  prev_cohort: string;
  new_cohort: string;
  user_id?: string;
  user_status?: 'free' | 'paid';
  paid_batch_type?: 'booster' | 'master';
  source?: 'app' | 'web';
  user_country?: string;
  flow?: 'revamped' | 'old';
}

export interface CohortChangeParams {
  came_from: 'dropdown' | 'profile' | 'home' | 'explore';
  page: 'home' | 'paid';
  prev_cohort: string;
  new_cohort: string;
  switch_type: 'exploring' | 'profile_switch';
  user_id: string;
  user_status?: 'free' | 'paid';
  paid_batch_type?: 'booster' | 'master';
  source?: 'web';
  user_country?: string;
  flow?: 'revamped' | 'old';
}

export interface BatchExploreClickParams {
  page: 'home' | 'paid';
  batch_id: string;
  batch_name: string;
  batch_class?: string;
  batch_type?: 'booster' | 'master';
  batch_country?: string;
  selected_cohort?: string;
  flow?: 'revamped' | 'old';
  from?: TriggeredFromSection;
}

export interface BatchShareClickParams {
  batch_id: string;
  batch_name: string;
  batch_class?: string;
  selected_cohort?: string;
  batch_type?: 'booster' | 'master';
  user_status?: 'free' | 'paid';
  user_id: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web';
  user_country?: string;
  batch_country?: string;
  flow?: 'revamped' | 'old';
}

export interface BuyNowClickParams {
  from: 'card' | 'batch_page' | 'quiz_result_page' | 'track_nudge' | 'all_listing' | 'inside_track';
  track_type?: 'brainBytes' | 'practice' | 'animated';
  batch_id: string;
  user_cohort: string;
  batch_name: string;
  batch_type?: 'booster' | 'master';
  batch_class?: string;
  selected_cohort?: string;
  sub_total?: number;
  discount?: number;
  total_amount?: number;
  user_id: string;
  user_name?: string;
  user_class?: string;
  source?: 'app';
  user_status?: 'free' | 'paid';
  page?: 'home' | 'paid';
  user_country?: string;
  batch_country?: string;
  currency?: string;
  triggered_from?: 'PTM_Offer' | 'alterate_offering_card';
  flow?: 'revamped' | 'old';
}

export interface TrackContentOpenParams {
  from: 'home' | 'all_listing' | 'link' | 'deeplink';
  user_cohort?: string;
  selected_cohort?: string;
  user_id?: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web' | 'mweb';
  user_status?: 'free' | 'paid';
  user_country?: string;
  flow?: 'revamped' | 'old';
  track_type: 'brainBytes' | 'practice' | 'animated';
  track_status?: 'unlocked' | 'locked';
  track_order?: number;
  track_unlock_in?: string;
  content_id?: string;
  content_title?: string;
  track_state?: 'new' | 'completed' | 'in_progress';
  track_content_id?: string;
  quiz_name?: string;
  total_question?: number;
  quiz_subject?: string;
  click_type?: 'start' | 'results';
  Page?: 'home' | 'paid' | 'learn_play_page';
}

export interface ViewAllTrackClickParams {
  from: 'home';
  user_cohort: string;
  selected_cohort?: string;
  user_id: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web' | 'mweb';
  user_status?: 'free' | 'paid';
  user_country?: string;
  flow?: 'revamped' | 'old';
  track_type: 'brainBytes' | 'practice' | 'animated';
}

export interface AllTrackPageOpenParams {
  from: 'home' | 'explore' | 'deeplink' | 'paid';
  user_cohort: string;
  selected_cohort?: string;
  user_id: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web';
  user_status?: 'free' | 'paid';
  batch_id?: string;
  user_country?: string;
  flow?: 'revamped' | 'old';
  track_type: 'brainBytes' | 'practice' | 'animated';
}

export interface TrackPurchasePopupParams {
  from: 'home' | 'all_listing' | 'inside_track';
  user_cohort: string;
  selected_cohort?: string;
  user_id: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web';
  user_status?: 'free' | 'paid';
  user_country?: string;
  flow?: 'revamped' | 'old';
  track_type: 'brainBytes' | 'practice' | 'animated';
}

export interface TaggedBatchesPopupParams {
  user_id?: string;
  selected_cohort?: string;
  user_cohort?: string;
  selected_cohort_name?: string;
  flow?: string;
  source?: string;
  batch_id: string;
  batch_name: string;
  batch_type?: BatchPageVisitBatchType;
  user_class?: string;
  user_name?: string;
  batches_shown?: string | string[];
  batches_shown_name?: string;
  page: 'home' | 'paid' | 'explore';
  user_status?: 'free' | 'paid';
  is_PTM?: 'Yes' | 'No';
  triggered_from?: string;
  recommended_plan?: 'yes' | 'no';
  default_batch?: string;
  section_trigger_from?: string;
  experiment_name?: string;
  tagged_booster_batch_id?: string;
}

export interface TaggedBatchSelectedParams {
  selected_cohort_name?: string;
  flow?: string;
  source?: string;
  batch_id: string;
  batch_name: string;
  page: 'home' | 'paid';
  user_status?: 'free' | 'paid';
  is_PTM?: 'Yes' | 'No';
  /** Include BatchPageVisitTriggeredFrom (home, batch_lisiting_page, etc.) when passed from URL/searchParams */
  triggered_from?:
    | 'batch_card'
    | 'batch_page'
    | 'track_popup'
    | 'all_listing'
    | 'inside_track'
    | 'batch_page_visit'
    | BatchPageVisitTriggeredFrom
    | string;
  batch_duration?: string;
  recommended_plan?: 'yes' | 'no';
  selected_cohort?: string;
  default_batch?: string;
  batch_plan_name?: string;
  tagged_booster_batch_id?: string;
}

export interface ContinueToPayClickParams {
  batch_id: string;
  user_cohort?: string;
  batch_name?: string;
  batch_type: 'booster' | 'master';
  batch_class?: string;
  selected_cohort?: string;
  sub_total: string;
  discount: string;
  total_amount: string;
  user_id?: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web';
  user_status?: 'free' | 'paid';
  page: 'home' | 'paid';
  user_country?: string;
  batch_country?: string;
  currency?: string;
  triggered_from?:
    | 'batch_card'
    | 'track_popup'
    | 'all_listing'
    | 'inside_track'
    | 'batch_page'
    | 'quiz_result_page';
  flow?: 'revamped' | 'old';
  batch_duration?: string;
  recommended_plan?: 'yes' | 'no';
  from?: string;
}

export interface TransactionSuccessParams {
  batch_id: string;
  batch_name: string;
  selected_cohort?: string;
  batch_type: BatchPageVisitBatchType;
  order_id: string;
  sub_total: string;
  coupon_code?: string;
  discount: string;
  total_amount: string;
  source?: 'app' | 'web';
  paid_batch_type?: 'booster' | 'master' | 'both';
  batch_country?: string;
  currency?: string;
  came_from?: string;
  triggered_from?: BatchPageVisitTriggeredFrom | string;
  flow?: 'revamped' | 'old';
  default_batch?: string;
  from?: TriggeredFromSection;
  experiment_name?: string;
  tagged_booster_batch_id?: string;
}

export interface TransactionFailedParams {
  batch_id: string;
  batch_name: string;
  batch_class?: string;
  batch_type: BatchPageVisitBatchType;
  order_id: string;
  sub_total: string;
  coupon_code?: string;
  discount: string;
  total_amount: string;
  source?: 'app' | 'web';
  batch_country?: string;
  currency?: string;
  triggered_from?: BatchPageVisitTriggeredFrom | string;
  flow?: 'revamped' | 'old';
  failure_reason?: string;
  from?: TriggeredFromSection;
  default_batch?: string;
  came_from?: string;
  experiment_name?: string;
  tagged_booster_batch_id?: string;
}

/** batch_type for events (payment, batch_page_visit, etc.) */
export enum BatchTypeForEvent {
  Booster = 'booster',
  Master = 'master',
  Power = 'power',
  PocketCourse = 'pocket_course',
  Mega = 'mega',
}

export type BatchPageVisitBatchType = `${BatchTypeForEvent}`;

/** triggered_from for batch_page_visit and payment events */
export enum TriggeredFromForEvent {
  Home = 'home',
  BatchListingPage = 'batch_lisiting_page',
  CompareBatchesPage = 'compare_batches_page',
  BatchPageVisit = 'batch_page_visit',
  PTMOffer = 'PTM_Offer',
  AlternateOfferingCard = 'alterate_offering_card',
  RetentionFlow = 'retention_flow',
  VideoPlayerFomo = 'video_player_fomo',
  ExploreTab = 'explore_tab',
  ViewDetails = 'view_details',
  Deeplink = 'deeplink',
  MyPurchases = 'my_purchases',
}

export type BatchPageVisitTriggeredFrom = `${TriggeredFromForEvent}`;

/** Params for compare_batches_page / batch_listing_page events. Globals (user_id, user_cohort, etc.) merged in tracker. */
export interface CompareBatchesPageParams {
  batches_shown?: string | string[];
  recommended_batch_id?: string;
  batch_class?: string;
  triggered_from: BatchPageVisitTriggeredFrom | string;
  experiment_name?: string;
  came_from?: string;
  source?: string;
  retention_flow?: string;
}

export interface BatchListingPageParams {
  batches_shown?: string | string[];
  recommended_batch_id?: string;
  batch_class?: string;
  triggered_from: BatchPageVisitTriggeredFrom | string;
  experiment_name?: string;
  came_from?: string;
  source?: string;
  retention_flow?: string;
}

const BATCH_PAGE_VISIT_TRIGGERED_FROM_VALUES: BatchPageVisitTriggeredFrom[] = [
  TriggeredFromForEvent.Home,
  TriggeredFromForEvent.BatchListingPage,
  TriggeredFromForEvent.CompareBatchesPage,
  TriggeredFromForEvent.BatchPageVisit,
  TriggeredFromForEvent.PTMOffer,
  TriggeredFromForEvent.AlternateOfferingCard,
  TriggeredFromForEvent.RetentionFlow,
  TriggeredFromForEvent.VideoPlayerFomo,
  TriggeredFromForEvent.ExploreTab,
  TriggeredFromForEvent.ViewDetails,
  TriggeredFromForEvent.Deeplink,
  TriggeredFromForEvent.MyPurchases,
];

export function getValidatedBatchPageVisitTriggeredFrom(
  value: string | null
): BatchPageVisitTriggeredFrom {
  if (
    value &&
    BATCH_PAGE_VISIT_TRIGGERED_FROM_VALUES.includes(value as BatchPageVisitTriggeredFrom)
  ) {
    return value as BatchPageVisitTriggeredFrom;
  }
  return TriggeredFromForEvent.BatchPageVisit;
}

/** experiment_name values (e.g. for mega batch experiment) */
export enum ExperimentNameForEvent {
  PreBoosterMegaControl = 'pre_booster_mega(control)',
  PostBoosterMegaTarget = 'post_booster_mega(target)',
  Mega = 'mega',
}

export interface BatchPageVisitParams {
  batch_id: string;
  batch_name: string;
  /** Prefer omitting – added globally via getUserParams() */
  user_cohort?: string;
  batch_type: BatchPageVisitBatchType;
  batch_class?: string;
  /** Prefer omitting – added globally */
  selected_cohort?: string;
  batch_status: 'free' | 'paid';
  item?: 'description' | 'study_room' | 'test';
  /** Prefer omitting – added globally via getUserParams() */
  user_id?: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web' | 'webapp';
  user_status?: 'free' | 'paid';
  paid_batch_type?: 'booster' | 'master' | 'both';
  user_country?: string;
  batch_country?: string;
  selected_cohort_name?: string;
  triggered_from?: BatchPageVisitTriggeredFrom;
  flow?: 'revamped' | 'old';
  experiment_name?: string;
  default_batch?: string;
  came_from?: string;
  /** e.g. 'mega' when mega batch */
  /** true when user opened pitch from recommended batch on listing */
  recommended_plan?: 'yes' | 'no';
  /** Batch id that was recommended to user (e.g. from home/listing); only set when this visit is for the recommended batch */
  recommended_batch_id?: string;
  /** true when batch has PTM / special offer */
  is_PTM?: 'Yes' | 'No';
  batch_currency?: string;
  tagged_booster_batch_id?: string;
  batch_price?: number;
}

export interface TransactionSuccessBoosterParams {
  came_from: 'website' | 'market' | 'blp';
  mlp_type: 'static' | 'video_mlp' | 'video_header' | 'horizontal';
  page_id?: string;
  batch_id: string;
  batch_name: string;
  selected_cohort?: string;
  user_cohort: string;
  batch_type: 'booster' | 'master';
  order_id: string;
  sub_total: string;
  coupon_code?: string;
  discount: string;
  total_amount: string;
  user_id: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web';
  user_status?: 'free' | 'paid';
  paid_batch_type?: 'booster' | 'master' | 'both';
  user_country?: string;
  batch_country?: string;
  currency?: string;
  flow?: 'revamped' | 'old';
}

export interface FaqClickParams {
  faq_id: string;
  batch_id: string;
  batch_name: string;
  batch_class?: string;
  batch_status: 'free' | 'paid';
  batch_type: 'booster' | 'master' | 'mega' | 'power';
  user_id: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web';
  user_status?: 'free' | 'paid';
  user_country?: string;
  batch_country?: string;
  flow?: 'revamped' | 'old';
}

export interface TrackContentClickParams {
  from: 'home' | 'all_listing';
  user_cohort: string;
  selected_cohort?: string;
  user_id: string;
  user_name?: string;
  user_class?: string;
  source?: 'app' | 'web' | 'mweb';
  user_status?: 'free' | 'paid';
  user_country?: string;
  flow?: 'revamped' | 'old';
  track_type: 'brainBytes' | 'practice' | 'animated';
  track_status: 'unlocked' | 'locked';
  track_order: number;
  track_unlock_in?: string; // ISO Date time String
  track_content_id?: string;
  quiz_name?: string;
  total_question?: number;
  quiz_subject?: string;
  click_type?: 'start' | 'results';
  Page?: 'home' | 'paid' | 'learn_play_page';
}

// Note: user_id, user_class, user_cohort, user_name, source, etc. are injected
// globally by trackGaEvent/trackMoengageEvent (getUserParams), so they are
// intentionally omitted from these interfaces to avoid duplication.
export interface MentorChatIntroBsParams {
  batch_id: string;
  batch_name: string;
  batch_type: string;
  batch_class: string;
}

export interface MentorChatScreenOpenedParams {
  conversation_id: string;
  mentor_id: string;
  mentor_name: string;
  device_id: string;
  os_version: string;
  user_type: 'student' | string;
  batch_id: string;
  platform: string;
  from:
    | 'message_notifications'
    | 'call_notification'
    | 'bottom_bar'
    | 'intro_screen'
    | 'streak_lost';
  app_version: string;
  env: string;
}

export interface MentorChatMessageSentParams {
  device_id: string;
  os_version: string;
  batch_id: string;
  user_type: 'student' | string;
  platform: string;
  app_version: string;
  env: string;
  conversation_id: string;
  mentor_id: string;
  mentor_name: string;
  message_type: string;
}
export interface MentorChatAppDownloadParams {
  device_id: string;
  os_version: string;
  user_id: string;
  batch_id: string;
  user_type: 'student' | string;
  platform: string;
  mentor_id: string;
  mentor_name: string;
  app_version: string;
  env: string;
  user_class: string;
  user_cohort: string;
}

/** Cohort and paid-batch fields that `trackGaEvent` does not inject on its own. */
export interface StreakAnalyticsContextParams {
  selected_cohort_name: string;
  paid_batch_name: string;
  paid_batch_id: string;
}

export type FloatingNotificationMessage =
  | 'cold_start'
  | 'streak_lost'
  | 'streak_onboarding'
  | 'streak_restored_by_mentor'
  | 'life_used'
  | 'streak_at_risk';

export interface FloatingNotificationShownParams extends StreakAnalyticsContextParams {
  message: FloatingNotificationMessage;
}

export interface FloatingNotificationClickedParams extends StreakAnalyticsContextParams {
  action_performed: 'streak_onboarding' | 'cold_start' | 'streak_lost';
}

export interface StreakActNowClickedParams extends StreakAnalyticsContextParams {
  page: 'streak_page';
  action_performed: 'streak_at_risk' | 'lives_low' | 'streak_lost';
}

export type DownloadButtonClickedParams = StreakAnalyticsContextParams;

/**
 * Coming-soon sheet only sends `bottom_sheet_shown`.
 * `resume_class` / `leave_class`, `schedule_id`, `schedule_type`, and `from`
 * belong to the in-class leave nudge and are not sent here.
 */
export interface BottomSheetInteractionParams extends StreakAnalyticsContextParams {
  action_performed: 'bottom_sheet_shown';
  triggered_from: 'inside_player' | 'streak_icon';
  bottom_sheet_name: 'streak_coming_soon';
}

export interface AskMentorChatSentParams {
  batch_id: string;
  batch_name: string;
  batch_type: string;
  source: string;
  assessment_id: string;
  question_id: string;
  assessment_type: string;
  subject: string;
  status: string;
  position_in_list?: number;
}
